import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Forgotemail from '../components/Forgotemail';

const Forgotenemail = () => {
    return (
        <div>
            <Header />
            <Forgotemail />
            <Footer />
        </div>
    );
};

export default Forgotenemail;
